export default class Descuento {
  /** @type {number?} */ descuento = null
  /** @type {number?} */ cuota = null
}
